/**
 * The one place a user can turn session replay off.
 *
 * The switch shows whether recording is ALLOWED, so it reads "on" by
 * default and the user turns it off — which is the inverse of the stored
 * value, an opt-OUT. Storing the negative is what keeps "not recorded"
 * from being the state a cleared browser lands in.
 *
 * It is rendered whether or not PostHog is currently able to record — in
 * development it never is. The preference is still real and still
 * honoured the moment recording becomes possible, and the copy claims
 * only that, never that a recording is running right now.
 */

import { useTranslation } from "react-i18next";
import { Switch } from "@/components/ui/switch";
import { useReplayOptedOut } from "@/hooks/use-session-replay";
import { setReplayOptedOut } from "@/lib/session-replay";

export function SessionReplayToggle() {
	const { t } = useTranslation();
	const optedOut = useReplayOptedOut();

	return (
		<div className="flex items-start justify-between gap-4">
			<div className="space-y-1">
				<label
					htmlFor="session-replay-toggle"
					className="text-sm font-medium text-[var(--color-dashboard-text)]"
				>
					{t("settings.sessionReplay")}
				</label>
				<p
					id="session-replay-toggle-description"
					className="text-sm text-muted-foreground"
				>
					{t("settings.sessionReplayDescription")}
				</p>
			</div>
			<Switch
				id="session-replay-toggle"
				aria-describedby="session-replay-toggle-description"
				checked={!optedOut}
				onCheckedChange={(allowed) => setReplayOptedOut(!allowed)}
			/>
		</div>
	);
}
